import Swiper from "swiper/bundle";

import "swiper/css/bundle";

export default class Slider {
  constructor() {
    const swiper = new Swiper(".wp-block-create-block-staff-slider", {
      spaceBetween: 16,
      slidesPerView: 1.2,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 500,
      autoplay: {
        delay: 3000, 
        disableOnInteraction: false,
        waitForTransition: false,
      },
      breakpoints: {
        780: {
          spaceBetween: 30,
          slidesPerView: 2,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}
